'use client';

export default function useIsMac() {
  return /Mac/.test(navigator.userAgent);
}
